import React from "react";
import { getLoadingTranslation } from "../lib/localizedText";

const Spinner = ({ locale = "GB" }) => {
  const { spinnerMessage } = getLoadingTranslation(locale);

  return (
    <div className="spinner__container">
      <div className="spinner" />
      <div className="spinner__container--text">
        <p>{spinnerMessage}</p>
      </div>
    </div>
  );
};

export default Spinner;
